/* ============================================
   SOUTHPAW GALLERY - JAVASCRIPT v4
   ============================================ */
(function() {
  'use strict';

  /* --- Configuration --- */
  var SLIDE_INTERVAL = 8000;
  var FADE_DURATION = 1500;
  var KB_CLASSES = ['kb-1','kb-2','kb-3','kb-4','kb-5','kb-6'];
  var FILTER_DELAY = 400;
  var BANNER_INTERVAL = 5000;

  /* --- Audio URLs per category (replace with actual MP3 URLs) --- */
  var CATEGORY_AUDIO = {
    'mse': '',
    'si': '',
    'soft-play': '',
    'murals': '',
    'projection': '',
    'de-escalation': ''
  };

  /* --- State --- */
  var currentCategory = 'all';
  var detailMode = false;
  var slideTimer = null;
  var currentSlideIndex = 0;
  var categorySlides = [];
  var audioEl = null;
  var isMuted = false;
  var userInteracted = false;
  var bannerTimer = null;
  var bannerIndex = 0;
  var lightboxOpen = false;
  var lightboxIndex = 0;
  var lightboxItems = [];
  var lightboxAtEnd = false;
  var lightboxEndSlide;
  var allMasonryItems = [];
  var isAllMode = false;
  var columnWrappers = [];
  var gallerySlideTimers = [];

  /* --- DOM References --- */
  var wrapper, slideshowSection, filterBar, masonry, muteBtn;
  var slideshowContainer, slideCounter, scrollHint;
  var prevBtn, nextBtn;
  var infoBar, infoText, viewGalleryBtn;
  var designsView;
  var bannerSlides, bannerScrollBtn;
  var lightboxOverlay, lightboxImg, lightboxClose, lightboxPrev, lightboxNext, lightboxCounter;
  var designGalleryItems;

  /* --- Initialize --- */
  function init() {
    wrapper = document.querySelector('.sp-gallery-wrapper');
    if (!wrapper) return;

    /* Class is added by inline script in section HTML for instant application
       to prevent layout jump. Add it here too as a fallback. */
    document.body.classList.add('sp-gallery-active');

    slideshowSection = wrapper.querySelector('.sp-slideshow-section');
    filterBar = wrapper.querySelector('.sp-filter-bar');
    masonry = wrapper.querySelector('.sp-masonry');
    muteBtn = wrapper.querySelector('.sp-mute-btn');
    slideshowContainer = wrapper.querySelector('.sp-slides-container');
    slideCounter = wrapper.querySelector('.sp-slide-counter');
    scrollHint = wrapper.querySelector('.sp-scroll-hint');
    prevBtn = wrapper.querySelector('.sp-slide-prev');
    nextBtn = wrapper.querySelector('.sp-slide-next');
    infoBar = wrapper.querySelector('.sp-info-bar');
    infoText = wrapper.querySelector('.sp-info-text');
    viewGalleryBtn = wrapper.querySelector('.sp-view-gallery-btn');
    designsView = wrapper.querySelector('.sp-designs-view');

    /* Design Book elements */
    bannerScrollBtn = wrapper.querySelector('.sp-db-scroll-btn');
    lightboxOverlay = wrapper.querySelector('.sp-db-lightbox');
    if (lightboxOverlay) {
      /* Move lightbox to body so it escapes wrapper stacking context */
      document.body.appendChild(lightboxOverlay);
      lightboxImg = lightboxOverlay.querySelector('.sp-db-lightbox-img');
      lightboxClose = lightboxOverlay.querySelector('.sp-db-lightbox-close');
      lightboxPrev = lightboxOverlay.querySelector('.sp-db-lightbox-prev');
      lightboxNext = lightboxOverlay.querySelector('.sp-db-lightbox-next');
      lightboxCounter = lightboxOverlay.querySelector('.sp-db-lightbox-counter');
      lightboxEndSlide = lightboxOverlay.querySelector('.sp-db-lightbox-end');
    }

    audioEl = document.createElement('audio');
    audioEl.loop = true;
    audioEl.volume = 0.3;
    document.body.appendChild(audioEl);

    /* Store all masonry items for column redistribution */
    storeAllItems();

    bindFilterButtons();
    bindMasonryClicks();
    bindSlideshowControls();
    bindMuteButton();
    bindKeyboard();
    bindViewGalleryButton();
    bindBannerScrollButton();
    bindDesignGallery();
    bindLightbox();
    bindZoomImages();
    bindBannerClick();
    bindTimelineClick();
    initScrollAnimations();
    initGallerySlideshow();
    checkHashNavigation();

    /* Start in ALL column mode (unless hash navigated to design book) */
    if (currentCategory !== 'designs') {
      enterAllMode();
    }

    document.addEventListener('click', function() {
      userInteracted = true;
    }, { once: true });
  }

  /* --- Hash-based Navigation (e.g. #design-book) --- */
  function checkHashNavigation() {
    var hash = window.location.hash.toLowerCase();
    if (hash === '#design-book' || hash === '#designbook') {
      var dbBtn = wrapper.querySelector('.sp-filter-btn[data-category="designs"]');
      if (dbBtn) {
        setActiveFilter(dbBtn);
        showDesignsView();
        window.scrollTo({ top: 0 });
      }
    }
  }

  /* --- Filter Buttons --- */
  function bindFilterButtons() {
    var buttons = wrapper.querySelectorAll('.sp-filter-btn');
    buttons.forEach(function(btn) {
      /* Skip the Enquire Today link - it opens a new tab natively */
      if (btn.classList.contains('sp-enquire-btn')) return;

      btn.addEventListener('click', function() {
        var cat = this.getAttribute('data-category');
        setActiveFilter(this);

        if (detailMode) {
          closeDetailView();
        }

        if (cat === 'designs') {
          showDesignsView();
        } else {
          hideDesignsView();
          filterGallery(cat);
        }
      });
    });
  }

  function setActiveFilter(activeBtn) {
    wrapper.querySelectorAll('.sp-filter-btn').forEach(function(b) {
      b.classList.remove('sp-active');
    });
    activeBtn.classList.add('sp-active');
  }

  function filterGallery(category) {
    currentCategory = category;

    if (category === 'all') {
      enterAllMode();
      setTimeout(function() { checkScrollAnimations(); }, 100);
      return;
    }

    /* Exit column mode when filtering to a specific category */
    exitAllMode();

    var items = masonry.querySelectorAll('.sp-masonry-item');

    items.forEach(function(item) {
      var itemCat = item.getAttribute('data-category');
      var shouldShow = (itemCat === category);

      if (!shouldShow) {
        item.classList.add('sp-hiding');
        setTimeout(function() {
          item.classList.add('sp-item-hidden');
          item.classList.remove('sp-hiding');
        }, FILTER_DELAY);
      } else {
        item.classList.remove('sp-item-hidden');
        /* Reset fade-in state so items animate in fresh */
        item.classList.remove('sp-visible');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            item.classList.remove('sp-hiding');
          });
        });
      }
    });

    /* Re-observe filtered items so fade-in triggers for newly visible ones */
    setTimeout(function() { checkScrollAnimations(); }, FILTER_DELAY + 100);
  }

  /* --- ALL Mode Column Functions --- */
  function storeAllItems() {
    allMasonryItems = Array.from(masonry.querySelectorAll('.sp-masonry-item'));
  }

  function getCategoryColumn(cat) {
    switch (cat) {
      case 'mse': return 0;
      case 'si': return 1;
      case 'soft-play': case 'de-escalation': return 2;
      case 'projection': case 'murals': return 3;
      default: return 0;
    }
  }

  function enterAllMode() {
    if (isAllMode) return;
    exitAllMode();
    isAllMode = true;
    masonry.classList.add('sp-all-mode');

    /* Create 4 column wrappers */
    var cols = [];
    for (var i = 0; i < 4; i++) {
      var col = document.createElement('div');
      col.className = 'sp-masonry-col';
      cols.push(col);
    }
    columnWrappers = cols;

    /* Sort items into category buckets first so we control order within col 4 */
    var buckets = { 0: [], 1: [], 2: [], 3: [] };
    /* Col 3 sub-buckets: projection first, then murals */
    var projItems = [];
    var muralItems = [];

    allMasonryItems.forEach(function(item) {
      item.classList.remove('sp-item-hidden', 'sp-hiding');
      var cat = item.getAttribute('data-category');
      var colIdx = getCategoryColumn(cat);
      if (colIdx === 3) {
        if (cat === 'projection') projItems.push(item);
        else muralItems.push(item);
      } else {
        buckets[colIdx].push(item);
      }
    });
    /* Column 3 = projection first, then murals */
    buckets[3] = projItems.concat(muralItems);

    /* Append category items to their columns */
    for (var c = 0; c < 4; c++) {
      buckets[c].forEach(function(item) {
        cols[c].appendChild(item);
      });
    }

    /* Append columns to masonry */
    cols.forEach(function(col) {
      masonry.appendChild(col);
    });

    /* Re-trigger fade-in */
    allMasonryItems.forEach(function(item) {
      item.classList.remove('sp-visible');
    });
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        checkScrollAnimations();
      });
    });

    /* Balance columns after images load so pixel heights are accurate */
    waitForImages(masonry, function() {
      balanceColumnsByHeight(cols);
    });
  }

  function waitForImages(container, callback) {
    var done = false;
    function runOnce() {
      if (done) return;
      done = true;
      callback();
    }
    var imgs = container.querySelectorAll('img');
    var total = imgs.length;
    var loaded = 0;
    if (total === 0) { runOnce(); return; }
    function check() {
      loaded++;
      if (loaded >= total) runOnce();
    }
    imgs.forEach(function(img) {
      if (img.complete) { check(); }
      else {
        img.addEventListener('load', check);
        img.addEventListener('error', check);
      }
    });
    /* Safety timeout - don't wait forever */
    setTimeout(runOnce, 6000);
  }

  function balanceColumnsByHeight(cols) {
    var maxMoves = 80;
    var moved = 0;

    while (moved < maxMoves) {
      var heights = cols.map(function(col) { return col.scrollHeight; });
      var maxH = Math.max.apply(null, heights);
      var minH = Math.min.apply(null, heights);

      /* Stop if within ~2 image heights of each other (~700px) */
      if (maxH === 0 || (maxH - minH) < 700) break;

      var tallIdx = heights.indexOf(maxH);
      var shortIdx = heights.indexOf(minH);
      if (tallIdx === shortIdx) break;

      /* Don't empty columns - keep at least 5 items */
      if (cols[tallIdx].children.length <= 5) break;

      var lastItem = cols[tallIdx].lastElementChild;
      if (!lastItem || !lastItem.classList.contains('sp-masonry-item')) break;

      cols[shortIdx].appendChild(lastItem);
      moved++;
    }
  }

  function exitAllMode() {
    if (!isAllMode) return;
    isAllMode = false;
    masonry.classList.remove('sp-all-mode');

    /* Move items back to masonry root (in original order) */
    allMasonryItems.forEach(function(item) {
      masonry.appendChild(item);
    });

    /* Remove column wrappers */
    columnWrappers.forEach(function(col) {
      if (col.parentNode) col.parentNode.removeChild(col);
    });
    columnWrappers = [];
  }

  /* --- Gallery Pair Slideshow --- */
  function initGallerySlideshow() {
    var items = document.querySelectorAll('.sp-db-gallery-item');
    items.forEach(function(item) {
      var imgs = item.querySelectorAll('img');
      if (imgs.length <= 1) return;

      /* Mark extra images as overlay slides */
      for (var i = 1; i < imgs.length; i++) {
        imgs[i].classList.add('sp-db-gslide');
      }

      var currentIdx = 0;
      var total = imgs.length;
      var overlays = Array.from(imgs).slice(1);

      var timer = setInterval(function() {
        /* Fade out current overlay */
        if (currentIdx > 0) {
          overlays[currentIdx - 1].classList.remove('sp-db-gslide-active');
        }
        currentIdx = (currentIdx + 1) % total;
        /* Fade in next overlay */
        if (currentIdx > 0) {
          overlays[currentIdx - 1].classList.add('sp-db-gslide-active');
        }
      }, 4000);

      gallerySlideTimers.push(timer);
    });
  }

  /* --- Designs View --- */
  function showDesignsView() {
    currentCategory = 'designs';
    exitAllMode();
    if (masonry) masonry.style.display = 'none';
    if (designsView) designsView.classList.add('sp-active');
    startBannerRotation();
    /* Re-check scroll animations for newly visible elements */
    setTimeout(function() { checkScrollAnimations(); }, 100);
  }

  function hideDesignsView() {
    if (designsView) designsView.classList.remove('sp-active');
    if (masonry) masonry.style.display = '';
    stopBannerRotation();
  }

  /* --- Banner Image Rotation --- */
  function startBannerRotation() {
    bannerSlides = wrapper.querySelectorAll('.sp-db-banner-slide');
    if (!bannerSlides || bannerSlides.length === 0) return;

    bannerIndex = 0;
    bannerSlides.forEach(function(s, i) {
      if (i === 0) s.classList.add('sp-active');
      else s.classList.remove('sp-active');
    });

    stopBannerRotation();
    bannerTimer = setInterval(function() {
      bannerSlides[bannerIndex].classList.remove('sp-active');
      bannerIndex = (bannerIndex + 1) % bannerSlides.length;
      bannerSlides[bannerIndex].classList.add('sp-active');
    }, BANNER_INTERVAL);
  }

  function stopBannerRotation() {
    if (bannerTimer) {
      clearInterval(bannerTimer);
      bannerTimer = null;
    }
  }

  /* --- Banner Scroll Button --- */
  function bindBannerScrollButton() {
    if (!bannerScrollBtn) return;
    bannerScrollBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var banner = wrapper.querySelector('.sp-db-banner');
      if (banner) {
        var target = banner.offsetTop + banner.offsetHeight;
        window.scrollTo({ top: target, behavior: 'smooth' });
      }
    });
  }

  /* --- Collect ALL Design Book Images for unified lightbox --- */
  function collectDesignBookImages() {
    var images = [];

    /* 1. Banner images (from background-image) */
    var slides = wrapper.querySelectorAll('.sp-db-banner-slide');
    slides.forEach(function(s) {
      var bg = s.style.backgroundImage;
      var match = bg.match(/url\(['"]?(.+?)['"]?\)/);
      if (match) {
        images.push({ src: match[1], alt: 'Design Book' });
      }
    });

    /* 2. Gallery images */
    var galleryImgs = wrapper.querySelectorAll('.sp-db-gallery-item img');
    galleryImgs.forEach(function(img) {
      images.push({ src: img.getAttribute('data-full') || img.src, alt: img.alt || '' });
    });

    /* 3. Timeline image */
    var timelineImg = wrapper.querySelector('.sp-db-timeline-img');
    if (timelineImg) {
      images.push({ src: timelineImg.src, alt: timelineImg.alt || 'Project Timeline' });
    }

    /* 4. Zoomable proposal images */
    var zoomImgs = wrapper.querySelectorAll('.sp-db-zoom-img');
    zoomImgs.forEach(function(img) {
      images.push({ src: img.src, alt: img.alt || '' });
    });

    return images;
  }

  function openDesignBookLightbox(clickedSrc) {
    lightboxItems = collectDesignBookImages();
    lightboxIndex = 0;

    for (var i = 0; i < lightboxItems.length; i++) {
      if (lightboxItems[i].src === clickedSrc) {
        lightboxIndex = i;
        break;
      }
    }

    showEndSlide(false);
    openLightbox();
  }

  /* --- Design Gallery & Lightbox --- */
  function bindDesignGallery() {
    var gallery = wrapper.querySelector('.sp-db-gallery-grid');
    if (!gallery) return;

    gallery.addEventListener('click', function(e) {
      var item = e.target.closest('.sp-db-gallery-item');
      if (!item) return;
      var clickedImg = item.querySelector('img');
      var clickedSrc = clickedImg.getAttribute('data-full') || clickedImg.src;
      openDesignBookLightbox(clickedSrc);
    });
  }

  /* --- Banner Click opens lightbox --- */
  function bindBannerClick() {
    var banner = wrapper.querySelector('.sp-db-banner');
    if (!banner) return;
    banner.addEventListener('click', function(e) {
      if (e.target.closest('.sp-db-banner-textbox') || e.target.closest('.sp-db-scroll-btn')) return;
      var activeSlide = banner.querySelector('.sp-db-banner-slide.sp-active');
      if (activeSlide) {
        var bg = activeSlide.style.backgroundImage;
        var match = bg.match(/url\(['"]?(.+?)['"]?\)/);
        if (match) openDesignBookLightbox(match[1]);
      }
    });
  }

  /* --- Timeline Image Click opens lightbox --- */
  function bindTimelineClick() {
    var timelineImg = wrapper.querySelector('.sp-db-timeline-img');
    if (!timelineImg) return;
    timelineImg.addEventListener('click', function() {
      openDesignBookLightbox(this.src);
    });
  }

  function openLightbox() {
    if (!lightboxOverlay) return;
    lightboxOpen = true;
    lightboxOverlay.classList.add('sp-active');
    document.body.style.overflow = 'hidden';
    showLightboxSlide();
  }

  function closeLightbox() {
    if (!lightboxOverlay) return;
    lightboxOpen = false;
    lightboxAtEnd = false;
    lightboxOverlay.classList.remove('sp-active');
    document.body.style.overflow = '';
    showEndSlide(false);
  }

  function showEndSlide(show) {
    lightboxAtEnd = show;
    if (lightboxEndSlide) {
      lightboxEndSlide.style.display = show ? 'flex' : 'none';
    }
    if (lightboxImg) {
      lightboxImg.style.display = show ? 'none' : '';
    }
    if (lightboxCounter) {
      lightboxCounter.style.display = show ? 'none' : '';
    }
  }

  function showLightboxSlide() {
    if (!lightboxImg || lightboxItems.length === 0) return;
    lightboxImg.src = lightboxItems[lightboxIndex].src;
    lightboxImg.alt = lightboxItems[lightboxIndex].alt;
    if (lightboxCounter) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxItems.length;
    }
  }

  function lightboxNext_fn() {
    if (lightboxAtEnd) return;
    if (lightboxIndex >= lightboxItems.length - 1) {
      showEndSlide(true);
      return;
    }
    lightboxIndex = lightboxIndex + 1;
    showLightboxSlide();
  }

  function lightboxPrev_fn() {
    if (lightboxAtEnd) {
      showEndSlide(false);
      showLightboxSlide();
      return;
    }
    lightboxIndex = (lightboxIndex - 1 + lightboxItems.length) % lightboxItems.length;
    showLightboxSlide();
  }

  function bindLightbox() {
    if (!lightboxOverlay) return;

    if (lightboxClose) {
      lightboxClose.addEventListener('click', function(e) {
        e.stopPropagation();
        closeLightbox();
      });
    }
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        lightboxPrev_fn();
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', function(e) {
        e.stopPropagation();
        lightboxNext_fn();
      });
    }

    /* Click outside image to close */
    lightboxOverlay.addEventListener('click', function(e) {
      if (e.target === lightboxOverlay) {
        closeLightbox();
      }
    });

    /* View Gallery button in end slide */
    if (lightboxEndSlide) {
      var viewBtn = lightboxEndSlide.querySelector('.sp-db-lightbox-view-gallery');
      if (viewBtn) {
        viewBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          closeLightbox();
          var allBtn = wrapper.querySelector('.sp-filter-btn[data-category="all"]');
          if (allBtn) {
            setActiveFilter(allBtn);
            hideDesignsView();
            filterGallery('all');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
    }
  }

  /* --- Zoomable Proposal Images --- */
  function bindZoomImages() {
    var zoomImgs = document.querySelectorAll('[data-zoomable]');
    zoomImgs.forEach(function(img) {
      img.addEventListener('click', function() {
        openDesignBookLightbox(this.src);
      });
    });
  }

  /* --- Scroll-In Animations (IntersectionObserver) --- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      /* Fallback: show everything */
      var items = document.querySelectorAll('.sp-fade-in');
      items.forEach(function(el) { el.classList.add('sp-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sp-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    var fadeItems = document.querySelectorAll('.sp-fade-in');
    fadeItems.forEach(function(el) {
      observer.observe(el);
    });

    /* Store observer for re-use when designs view becomes visible */
    window._spScrollObserver = observer;
  }

  function checkScrollAnimations() {
    if (!window._spScrollObserver) return;
    var newItems = document.querySelectorAll('.sp-fade-in:not(.sp-visible)');
    newItems.forEach(function(el) {
      window._spScrollObserver.unobserve(el);
      window._spScrollObserver.observe(el);
    });
  }

  /* --- Masonry Item Clicks --- */
  function bindMasonryClicks() {
    masonry.addEventListener('click', function(e) {
      var item = e.target.closest('.sp-masonry-item');
      if (!item) return;

      var img = item.querySelector('img');
      var imgSrc = img.getAttribute('data-full') || img.src;
      var imgAlt = img.getAttribute('alt') || '';
      var cat = item.getAttribute('data-category');

      if (currentCategory === 'all') {
        currentCategory = cat;
        var catBtn = wrapper.querySelector('.sp-filter-btn[data-category="' + cat + '"]');
        if (catBtn) setActiveFilter(catBtn);
        filterGallery(cat);
      }

      openDetailView(imgSrc, cat, imgAlt);
    });
  }

  /* --- Detail View (Slideshow) --- */
  function openDetailView(startImg, category, startAlt) {
    detailMode = true;
    document.body.classList.add('sp-detail-mode');

    categorySlides = [];
    var items = masonry.querySelectorAll('.sp-masonry-item[data-category="' + category + '"]');
    items.forEach(function(item) {
      var img = item.querySelector('img');
      var src = img.getAttribute('data-full') || img.src;
      var alt = img.getAttribute('alt') || '';
      categorySlides.push({ src: src, alt: alt });
    });

    if (categorySlides.length === 0) return;

    currentSlideIndex = -1;
    for (var i = 0; i < categorySlides.length; i++) {
      if (categorySlides[i].src === startImg) {
        currentSlideIndex = i;
        break;
      }
    }
    if (currentSlideIndex === -1) currentSlideIndex = 0;

    buildSlides();

    slideshowSection.classList.add('sp-active');

    if (infoBar) infoBar.classList.add('sp-active');
    updateInfoText();

    window.scrollTo({ top: 0, behavior: 'smooth' });

    startSlideshow();
    playAudio(category);
  }

  function closeDetailView() {
    detailMode = false;
    document.body.classList.remove('sp-detail-mode');

    stopSlideshow();
    stopAudio();

    slideshowSection.classList.remove('sp-active');
    if (infoBar) infoBar.classList.remove('sp-active');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function buildSlides() {
    slideshowContainer.innerHTML = '';

    categorySlides.forEach(function(slideData, i) {
      var slide = document.createElement('div');
      slide.className = 'sp-slide';
      if (i === currentSlideIndex) {
        slide.classList.add('sp-slide-active');
        slide.classList.add(getRandomKB());
      }
      var img = document.createElement('img');
      img.src = slideData.src;
      img.alt = slideData.alt;
      img.loading = (i <= currentSlideIndex + 1) ? 'eager' : 'lazy';
      slide.appendChild(img);
      slideshowContainer.appendChild(slide);
    });

    updateCounter();
  }

  function getRandomKB() {
    return KB_CLASSES[Math.floor(Math.random() * KB_CLASSES.length)];
  }

  function updateCounter() {
    if (slideCounter) {
      slideCounter.textContent = (currentSlideIndex + 1) + ' / ' + categorySlides.length;
    }
  }

  function updateInfoText() {
    if (!infoText) return;
    if (categorySlides.length > 0 && categorySlides[currentSlideIndex]) {
      var alt = categorySlides[currentSlideIndex].alt;
      infoText.textContent = alt || '';
    }
  }

  /* --- Slideshow Navigation --- */
  function goToSlide(index) {
    var slides = slideshowContainer.querySelectorAll('.sp-slide');
    if (slides.length === 0) return;

    var oldSlide = slides[currentSlideIndex];
    oldSlide.classList.remove('sp-slide-active');
    /* Keep KB class during fade-out so animation holds position (no jolt).
       Remove it AFTER the opacity transition finishes (1.6s). */
    (function(s) {
      setTimeout(function() {
        KB_CLASSES.forEach(function(kb) { s.classList.remove(kb); });
      }, 1700);
    })(oldSlide);

    currentSlideIndex = ((index % slides.length) + slides.length) % slides.length;

    var nextSlide = slides[currentSlideIndex];
    nextSlide.classList.add(getRandomKB());
    nextSlide.classList.add('sp-slide-active');

    var preloadIdx = (currentSlideIndex + 1) % slides.length;
    var preloadImg = slides[preloadIdx].querySelector('img');
    if (preloadImg && preloadImg.loading === 'lazy') {
      preloadImg.loading = 'eager';
    }

    updateCounter();
    updateInfoText();
  }

  function nextSlide() {
    goToSlide(currentSlideIndex + 1);
    resetSlideTimer();
  }

  function prevSlide() {
    goToSlide(currentSlideIndex - 1);
    resetSlideTimer();
  }

  function startSlideshow() {
    stopSlideshow();
    slideTimer = setInterval(function() {
      goToSlide(currentSlideIndex + 1);
    }, SLIDE_INTERVAL);
  }

  function stopSlideshow() {
    if (slideTimer) {
      clearInterval(slideTimer);
      slideTimer = null;
    }
  }

  function resetSlideTimer() {
    stopSlideshow();
    startSlideshow();
  }

  /* --- Slideshow Controls --- */
  function bindSlideshowControls() {
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); prevSlide(); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); nextSlide(); });
    if (scrollHint) scrollHint.addEventListener('click', function() {
      var target = slideshowSection.offsetHeight + slideshowSection.offsetTop + 100;
      window.scrollTo({ top: target, behavior: 'smooth' });
    });
  }

  /* --- View Gallery Button --- */
  function bindViewGalleryButton() {
    if (!viewGalleryBtn) return;
    viewGalleryBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var masonryTop = masonry.getBoundingClientRect().top + window.scrollY - 180;
      window.scrollTo({ top: masonryTop, behavior: 'smooth' });
    });
  }

  /* --- Keyboard Navigation --- */
  function bindKeyboard() {
    document.addEventListener('keydown', function(e) {
      /* Lightbox keyboard nav */
      if (lightboxOpen) {
        if (e.key === 'ArrowRight' || e.key === 'Right') lightboxNext_fn();
        else if (e.key === 'ArrowLeft' || e.key === 'Left') lightboxPrev_fn();
        else if (e.key === 'Escape') closeLightbox();
        return;
      }

      /* Slideshow keyboard nav */
      if (!detailMode) return;
      if (e.key === 'ArrowRight' || e.key === 'Right') nextSlide();
      else if (e.key === 'ArrowLeft' || e.key === 'Left') prevSlide();
      else if (e.key === 'Escape') closeDetailView();
    });
  }

  /* --- Audio --- */
  function playAudio(category) {
    var src = CATEGORY_AUDIO[category];
    if (!src || !userInteracted) return;

    audioEl.src = src;
    audioEl.muted = isMuted;
    audioEl.play().catch(function() {});
    muteBtn.classList.add('sp-audio-visible');
  }

  function stopAudio() {
    audioEl.pause();
    audioEl.src = '';
    muteBtn.classList.remove('sp-audio-visible');
  }

  function bindMuteButton() {
    if (!muteBtn) return;
    muteBtn.addEventListener('click', function() {
      isMuted = !isMuted;
      audioEl.muted = isMuted;
      muteBtn.classList.toggle('sp-muted', isMuted);
      updateMuteIcon();
    });
  }

  function updateMuteIcon() {
    var svg = muteBtn.querySelector('svg');
    if (!svg) return;
    if (isMuted) {
      svg.innerHTML = '<line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"/><path d="M17 14.3a6.73 6.73 0 0 0 .4-2.3 7 7 0 0 0-8.7-6.8"/><path d="M9.34 4.66A10 10 0 0 0 2 12a10 10 0 0 0 15.42 8.42"/>';
    } else {
      svg.innerHTML = '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>';
    }
  }

  /* --- Touch Swipe Support --- */
  (function initSwipe() {
    var startX = 0, startY = 0, threshold = 50;

    document.addEventListener('touchstart', function(e) {
      if (!detailMode && !lightboxOpen) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchend', function(e) {
      if (!detailMode && !lightboxOpen) return;
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var dx = endX - startX;
      var dy = endY - startY;

      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold) {
        if (lightboxOpen) {
          if (dx > 0) lightboxPrev_fn();
          else lightboxNext_fn();
        } else if (window.scrollY < window.innerHeight * 0.5) {
          if (dx > 0) prevSlide();
          else nextSlide();
        }
      }
    }, { passive: true });
  })();

  /* --- Init on DOM ready --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
